import React, { useState, useEffect } from "react";
import { Collapse, Select, message, Spin } from "antd";
import { useAuthState } from "react-firebase-hooks/auth";
import { RiArrowDownSLine, RiArrowUpSLine } from "react-icons/ri";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import RightBar from "../../components/common/RightBar";
import {
  collection,
  doc,
  getDocs,
  query,
  where,
  updateDoc,
} from "@firebase/firestore";
import { auth, db } from "../../firebase";

import MoveIns from "./Components/MoveIns";
import "./Dashboard.css";

import Footer from "../../components/common/Footer";

// Data from json file

import { DashboardRightBar, DashboardCards } from "./Data/DashboardData";
import UpcomingIncomeRecertifications from "./Components/UpcomingIncomeRecertifications";
import MoveOuts from "./Components/MoveOuts";
import AssociationApprovals from "./Components/AssociationApprovals";
import OnlinePayments from "./Components/OnlinePayments";
import Notifications from "./Components/Notifications";
import LeasingActivity from "./Components/LeasingActivity";
import PortfolioSummary from "./Components/PortfolioSummary";
import Delinquencies from "./Components/Delinquencies";
import Maintenance from "./Components/Maintenance";
import InsuranceCoverage from "./Components/InsuranceCoverage";

const { Panel } = Collapse;

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const filtersData = ["All", "test"];
const insurangeCoverageDropDown = ["By Tenant", "By Unit"];

const Dashboard = () => {
  const getItems = () => {
    // if (typeof window !== "undefined") {
    //   if (localStorage.getItem("items")) {
    //     return JSON.parse(localStorage.getItem("items"));
    //   }
    // }
    // localStorage.setItem("items", JSON.stringify(DashboardCards));
  };
  // localStorage.setItem("items", JSON.stringify(DashboardCards));

  const [items, setItems] = useState([]);
  const [data, setItemsData] = useState([]);
  const [isInitialRender, setIsInitialRender] = useState(true);
  const [isDraggable, setIsDraggable] = useState(false);
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");
  const [loadCompanyName, setLoadCompanyName] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);

  const fetchCompanyName = async () => {
    setDataLoading(true);

    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));

      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
            setLoadCompanyName(true);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    } finally {
      setDataLoading(false); // Set loading to false after fetching data or if an error occurs
    }
  };

  const handleFilterDataChange = (value) => {
    console.log(value);
  };

  useEffect(() => {
    if (isInitialRender) {
      setIsInitialRender(false);
      if (!items) {
        setItems(DashboardCards);
      }
      setItems((currentItems) => getItems(currentItems));
    }
    if (!isInitialRender) {
      localStorage.setItem("items", JSON.stringify(data));
    }
  }, [items, isInitialRender]);

  const handleOnDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const reorderedItems = reorder(
      data,
      result.source.index,
      result.destination.index
    );

    setItems(reorderedItems);

    setItemsData(reorderedItems);
    // localStorage.setItem("items", JSON.stringify(reorderedItems));
  };

  const handleDraggble = () => {
    setIsDraggable(true);
  };

  const handleDraggbleClose = () => {
    setIsDraggable(false);
  };

  function handleChange(event) {
    const hideItem = event.target.value;

    let objIndexfromItems = data.findIndex((obj) => obj.key === hideItem);

    if (data[objIndexfromItems].isHidden) {
      setItemsData(
        [...data].map((object) => {
          if (object.key === hideItem) {
            return {
              ...object,
              isHidden: false,
            };
          } else return object;
        })
      );
    } else {
      setItemsData(
        [...data].map((object) => {
          if (object.key === hideItem) {
            return {
              ...object,
              isHidden: true,
            };
          } else return object;
        })
      );
    }
  }

  const HandleClick = (id) => {
    const collapsedId = id;
    let objIndexfromItems = data.findIndex((obj) => obj.key === collapsedId);

    if (data[objIndexfromItems].isCollapsed) {
      setItemsData(
        [...data].map((object) => {
          if (object.key === collapsedId) {
            return {
              ...object,
              isCollapsed: false,
            };
          } else return object;
        })
      );
      // localStorage.setItem("items", JSON.stringify(items));
    } else {
      setItemsData(
        [...data].map((object) => {
          if (object.key === collapsedId) {
            return {
              ...object,
              isCollapsed: true,
            };
          } else return object;
        })
      );
      // localStorage.setItem("items", JSON.stringify(items));
    }
  };

  const dashboardData = {
    dashboardCards: DashboardCards,
  };
  const getDashboardData = async () => {
    const companiesRef = collection(db, "companies");
    const companyDocRef = doc(companiesRef, companyName);
    const userRef = collection(companyDocRef, "users");
    const querySnapshot = await getDocs(userRef);
    const filtredData = querySnapshot.docs.map((doc) => ({
      ...doc.data(),
    }));
    const results = filtredData?.filter((post) => {
      return post.uid === user.uid;
    });
    if (results) {
    }
    if (results[0]?.dashboardCards) {
      setItemsData(results[0]?.dashboardCards);
    } else {
      updateDashboardSettings(dashboardData);
      setItemsData(DashboardCards);
    }
  };

  // for updating data dashboard..
  const updateDashboardSettings = async (data) => {
    const companiesRef = collection(db, "companies");
    const companyDocRef = doc(companiesRef, companyName);
    const userRef = collection(companyDocRef, "users");
    try {
      const querySnapshot = await getDocs(userRef);
      querySnapshot.forEach(async (docData) => {
        if (user.uid === docData.data().uid) {
          // === doc.data().user.email
          const docRef = doc(userRef, docData.id);
          await updateDoc(docRef, data);

          message.success("Dashboard settings updated successfully.", 3);
        }
      });
    } catch (error) {
      console.error("Error updating dashboard settings:", error);
      message.error("Something went wrong!", 3);
    }
  };

  const handleSaveChanges = () => {
    const dataForUpdate = {
      dashboardCards: data,
    };
    updateDashboardSettings(dataForUpdate);
    // localStorage.setItem("items", JSON.stringify(items));
    // setItems(JSON.parse(localStorage.getItem("items")));
    setIsDraggable(false);
  };

  useEffect(() => {
    if (loadCompanyName) {
      getDashboardData();
    }
    fetchCompanyName();
  }, [loadCompanyName]);
  return (
    <div className="DashbaordPage">
      <Spin spinning={dataLoading}>
        <div className="page-container">
          <div className="main-container">
            {!isDraggable ? (
              <div className="pageheading">
                <h1>Dashboard</h1>
                <div className="filterNbtn">
                  {/* <label htmlFor="filter">View By </label>
                <Select
                  defaultValue={filtersData[0]}
                  style={{
                    width: 120,
                  }}
                  onChange={handleFilterDataChange}
                  options={filtersData.map((data) => ({
                    label: data,
                    value: data,
                  }))}
                  name="filter"
                /> */}
                  <button onClick={handleDraggble}>
                    <i className="fa-sharp fa-solid fa-gear"></i> Customize
                  </button>
                </div>
              </div>
            ) : (
              <div className="pageheading">
                <h1>
                  Dashboard <span>Saved</span>
                </h1>
                <div className="saveCancel">
                  <button onClick={handleSaveChanges}>Save</button>
                  <button onClick={handleDraggbleClose}>Cancel</button>
                </div>
              </div>
            )}
            <DragDropContext onDragEnd={handleOnDragEnd}>
              <Droppable droppableId="droppable">
                {(provided) => (
                  <div {...provided.droppableProps} ref={provided.innerRef}>
                    {data?.map((item, index) => (
                      <Draggable
                        key={item.key}
                        draggableId={item.key}
                        index={index}
                        isDragDisabled={!isDraggable}
                      >
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <div className={isDraggable ? "isDraggable" : ""}>
                              {isDraggable ? (
                                <div className="expandable-section__hidden_checkbox">
                                  <label className="js-hide-label">
                                    <input
                                      type="checkbox"
                                      className="hide-check-box"
                                      value={item.key}
                                      defaultChecked={item.isHidden}
                                      onChange={handleChange}
                                    />
                                    Hide from view
                                  </label>
                                </div>
                              ) : null}
                              {!isDraggable ? (
                                item.isHidden === false && (
                                  <Collapse
                                    expandIcon={({ isActive }) =>
                                      isActive ? (
                                        <RiArrowUpSLine />
                                      ) : (
                                        <RiArrowDownSLine />
                                      )
                                    }
                                    className="dashBoardPanel"
                                    onChange={() => HandleClick(item.key)}
                                    defaultActiveKey={item.isCollapsed ? 0 : ""}
                                  >
                                    {item.header === "Insurance Coverage" && (
                                      <div className="expandable-InsuranceCoverage">
                                        <Select
                                          defaultValue={
                                            insurangeCoverageDropDown[0]
                                          }
                                          style={{
                                            width: 120,
                                            marginRight: 5,
                                          }}
                                          onChange={handleFilterDataChange}
                                          options={insurangeCoverageDropDown.map(
                                            (data) => ({
                                              label: data,
                                              value: data,
                                            })
                                          )}
                                          name="filter"
                                        />
                                        <Select
                                          defaultValue="..."
                                          style={{
                                            width: 100,
                                          }}
                                          onChange={handleFilterDataChange}
                                          options={filtersData.map((data) => ({
                                            label: data,
                                            value: data,
                                          }))}
                                          name="filter"
                                          className="dotsInsurance"
                                        />
                                      </div>
                                    )}
                                    <Panel header={item.header}>
                                      {item.header === "Move Ins" && (
                                        <MoveIns />
                                      )}
                                      {item.header ===
                                        "Upcoming Income Recertifications" && (
                                        <UpcomingIncomeRecertifications />
                                      )}
                                      {item.header === "Move Outs" && (
                                        <MoveOuts />
                                      )}
                                      {item.header ===
                                        "Association Approvals" && (
                                        <AssociationApprovals />
                                      )}
                                      {item.header === "Online Payments" && (
                                        <OnlinePayments />
                                      )}
                                      {item.header === "Notifications" && (
                                        <Notifications />
                                      )}
                                      {item.header ===
                                        "Leasing Activity (Last 30 Days)" && (
                                        <LeasingActivity />
                                      )}
                                      {item.header === "Portfolio Summary" && (
                                        <PortfolioSummary />
                                      )}
                                      {item.header === "Delinquencies" && (
                                        <Delinquencies />
                                      )}
                                      {item.header === "Maintenance" && (
                                        <Maintenance />
                                      )}
                                      {item.header === "Insurance Coverage" && (
                                        <InsuranceCoverage />
                                      )}
                                    </Panel>
                                  </Collapse>
                                )
                              ) : (
                                <Collapse
                                  expandIcon={({ isActive }) =>
                                    isActive ? (
                                      <RiArrowUpSLine />
                                    ) : (
                                      <RiArrowDownSLine />
                                    )
                                  }
                                  className="dashBoardPanel"
                                >
                                  {item.header === "Insurance Coverage" && (
                                    <div className="expandable-InsuranceCoverage">
                                      <Select
                                        defaultValue={
                                          insurangeCoverageDropDown[0]
                                        }
                                        style={{
                                          width: 120,
                                          marginRight: 5,
                                        }}
                                        onChange={handleFilterDataChange}
                                        options={insurangeCoverageDropDown.map(
                                          (data) => ({
                                            label: data,
                                            value: data,
                                          })
                                        )}
                                        name="filter"
                                      />
                                      <Select
                                        defaultValue="..."
                                        style={{
                                          width: 100,
                                        }}
                                        onChange={handleFilterDataChange}
                                        options={filtersData.map((data) => ({
                                          label: data,
                                          value: data,
                                        }))}
                                        name="filter"
                                        className="dotsInsurance"
                                      />
                                    </div>
                                  )}
                                  <Panel header={item.header}>
                                    {item.header === "Move Ins" && <MoveIns />}
                                    {item.header ===
                                      "Upcoming Income Recertifications" && (
                                      <UpcomingIncomeRecertifications />
                                    )}
                                    {item.header === "Move Outs" && (
                                      <MoveOuts />
                                    )}
                                    {item.header ===
                                      "Association Approvals" && (
                                      <AssociationApprovals />
                                    )}
                                    {item.header === "Online Payments" && (
                                      <OnlinePayments />
                                    )}
                                    {item.header === "Notifications" && (
                                      <Notifications />
                                    )}
                                    {item.header ===
                                      "Leasing Activity (Last 30 Days)" && (
                                      <LeasingActivity />
                                    )}
                                    {item.header === "Portfolio Summary" && (
                                      <PortfolioSummary />
                                    )}
                                    {item.header === "Delinquencies" && (
                                      <Delinquencies />
                                    )}
                                    {item.header === "Maintenance" && (
                                      <Maintenance />
                                    )}
                                    {item.header === "Insurance Coverage" && (
                                      <InsuranceCoverage />
                                    )}
                                  </Panel>
                                </Collapse>
                              )}
                            </div>
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>

            {/* Footer  */}
            <Footer />
          </div>
        </div>

        <div className="RightSidebar">
          <RightBar RightBarData={DashboardRightBar} />
        </div>
      </Spin>
    </div>
  );
};

export default Dashboard;
